<template>
<b-row>
  <b-col>
    <b-row class="mb-1">
      <b-col class="text-right">
        <router-link
          :to="{name: 'ApplicationCreate' }"
          class="btn btn-sm btn-primary">{{$t('buttons.create')}}</router-link>
      </b-col>
    </b-row>
    <b-card>
      <template #header>
        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
            <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.application_filtering_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-collapse id="application_filtering_collapse" class="mt-2">
              <application-filtering ref="applicationFiltering" @getPage="getPage($event)"></application-filtering>
            </b-collapse>
          </b-col>
        </b-row>
      </template>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{$t('views.application.list.noApplications')}}
      </div>
      <table class="table table-responsive-md table-sm table-striped table-hover" v-else>
        <thead>
        <tr>
          <th>{{$t('views.application.list.status')}}</th>
          <th style="width: 20%">{{$t('views.application.form.idUserData')}}</th>
          <th>{{$t('views.application.list.application')}}</th>
          <th>{{$t('views.application.list.domain')}}</th>
          <th>{{$t('views.application.list.server')}}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>
            <applicationStatus :application-statuses="applicationStatuses" :item="item"/>
          </td>
          <td>
            <router-link v-if="item.idUserData" :to="{ name: 'FirmShow', params: {id: item.idUserData['@id']} }">
              {{ item.idUserData.firmname1 || item.idUserData.fullName }}
            </router-link>
          </td>
          <td>
            {{ item.applicationType.title }}
          </td>
          <td>
            <a target="_blank" :href="'//' +item.subdomain + '.' +  item.domain.domain">{{ item.subdomain }}.{{ item.domain.domain }}</a>
          </td>
          <td>
            <span v-if="item.server">{{item.server.title}} - {{item.server.host}}:{{item.server.port}}</span>
          </td>
          <td>
            <div class="btn-group float-right">
              <router-link
                tag="button"
                :to="{name: 'ApplicationShow', params: { id: item['@id'] }}"
                class="btn btn-link fa fa-search fa-lg"
                v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true">
              </router-link>
              <router-link
                tag="button"
                :to="{ name: 'ApplicationUpdate', params: { id: item['@id'] }}"
                class="btn btn-link fa fa-edit fa-lg"
                v-b-tooltip:hover :title="$t('buttons.edit')" >
              </router-link>
              <b-dropdown
                class="float-right"
                size="sm" variant="link"
                right text="Right align"
                toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item v-if="item.state === 1"
                                 @click="archiveItem(item['@id'])">
                  <i class="fa fa-key fa-lg"></i>
                  {{ $t('buttons.archive') }}
                </b-dropdown-item>
                <b-dropdown-item v-else
                                 @click="unArchiveItem(item['@id'])">
                  <i class="fa fa-key fa-lg"></i>
                  {{ $t('buttons.moveFromArchive') }}
                </b-dropdown-item>
                <b-dropdown-item v-if="item.blockStatus === applicationStatuses.APPLICATION_BLOCK"
                                 @click="changeApplicationStatus(item)"
                                :disabled="item.connectionStatus === applicationStatuses.CONNECTION_FAILURE">
                  <i class="fa fa-unlock fa-lg"></i>
                  {{ $t('buttons.unblockApplication') }}
                </b-dropdown-item>
                <b-dropdown-item v-else
                                 @click="changeApplicationStatus(item)"
                                 :disabled="item.connectionStatus === applicationStatuses.CONNECTION_FAILURE">
                  <i class="fa fa-lock fa-lg"></i>
                  {{ $t('buttons.blockApplication') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          :totalItems="totalItems"
          @getPage="getPage($event)"
          @getPageNumber="setCurrentPage($event.page)"
        ></pagination>
      </div>
    </b-card>
  </b-col>
</b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { applicationStatuses } from '@/utils/const/applicationStatuses'
//  import getId from '@/utils/getIdFromLink'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'
import ApplicationFiltering from '@/components/Dashboard/Views/IAMBundle/application/ApplicationFiltering'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { archive, unArchive } from '@/utils/archive'
import ApiService from '@/utils/ApiService'
import ApplicationStatus from '@/components/Dashboard/Views/IAMBundle/application/ApplicationStatus'

export default {
  components: {
    ApplicationStatus,
    Loader,
    Pagination,
    ApplicationFiltering
  },
  data () {
    return {
      applicationStatuses: applicationStatuses,
      searchParams: this.$store.state.filters.applicationFilter
    }
  },
  props: ['page'],
  computed: {
    ...mapGetters({
      deletedItem: 'application/del/deleted',
      error: 'application/list/error',
      items: 'application/list/items',
      isLoading: 'application/list/isLoading',
      view: 'application/list/view',
      totalItems: 'application/list/totalItems'
    }),
    filterStatus () {
      return JSON.stringify(this.$store.state.filters.applicationFilter) !== JSON.stringify(this.$store.state.filters.applicationFilterReference)
    }
  },
  beforeCreate () {
    if (Object.keys(this.$store.state.filters.applicationFilter).length === 0) {
      this.$store.state.filters.applicationFilter = JSON.parse(JSON.stringify(this.$store.state.filters.applicationFilterReference))
    }
  },
  created () {
    let params = Object.assign({ '_page': this.$store.state.filters.applicationFilterCurrentPage }, this.searchParams)
    let url = addParamsToQuery('applications', params)
    this.getPage(url)
  },
  methods: {
    setCurrentPage (page) {
      this.$store.state.filters.applicationFilterCurrentPage = page
    },
    clearFilters () {
      if (this.$refs.applicationFiltering) {
        this.$refs.applicationFiltering.clearFilter()
      }
    },
    ...mapMutations({
    }),
    ...mapActions({
      getPage: 'application/list/default'
    }),
    archiveItem (id) {
      archive(id, () => {
        this.getPage(this.view['@id'])
      })
    },
    unArchiveItem (id) {
      unArchive(id, () => {
        this.getPage(this.view['@id'])
      })
    },
    changeApplicationStatus (item) {
      if (item.connectionStatus === applicationStatuses.CONNECTION_SUCCESS) {
        let title, text
        if (item.blockStatus === applicationStatuses.APPLICATION_UNBLOCK) {
          title = this.$t('views.application.notifications.block.title')
          text = this.$t('views.application.notifications.block.text')
        } else {
          title = this.$t('views.application.notifications.unblock.title')
          text = this.$t('views.application.notifications.unblock.text')
        }
        this.$Swal({
          title: title,
          text: text,
          type: 'warning',
          showConfirmButton: true,
          confirmButtonText: this.$t('buttons.yes'),
          showCancelButton: true,
          cancelButtonText: this.$t('buttons.cancel')
        }).then(async (result) => {
          if (result) {
            const response = await new ApiService(`${item['@id']}/block`).post({})
            if (response.status === 200) {
              this.getPage(this.view['@id'])
            }
          }
        })
      }
    }
  }
}
</script>
